var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g7, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiabilityImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 199,
    viewBox: "0 0 300 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.107 195.664C270.893 202.302 307.619 181.643 298.622 151.843C291.269 127.493 225.974 106.811 178.487 72.9121C124.325 34.2617 188.022 13.1141 158.694 3.69313C104.334 -13.7397 7.78521 32.7479 0.771343 96.7731C-5.81072 156.827 31.371 184.718 50.0085 196.561C50.0085 196.561 227.421 193.754 237.107 195.664Z",
    fill: "#FDDC9D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1189_1531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 90,
    width: 27,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0878 160.379L36.1906 161.404C29.6085 132.443 23.3066 107.731 17.5298 90.7644C30.8106 99.2654 38.1862 125.665 43.0878 160.379Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1189_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0878 160.379L36.1906 161.404C29.6085 132.443 23.3066 107.731 17.5298 90.7644C30.8106 99.2654 38.1862 125.665 43.0878 160.379Z",
    fill: "#627A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1906 161.404C29.6085 132.443 23.3066 107.731 17.5298 90.7644C24.707 105.356 31.2891 126.69 36.1906 161.404Z",
    fill: "#424C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.3384 104.774L36.6805 140.885L34.043 140.816C34.043 140.816 28.0678 110.445 32.2925 104.716C35.14 100.861 35.3268 104.774 35.3268 104.774H35.3384Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1189_1531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 83,
    width: 14,
    height: 66
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9864 148.932H37.0192C34.7785 119.318 44.7099 103.97 49.4947 83.9985C48.4094 105.053 49.5881 113.298 43.9864 148.932Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1189_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9864 148.932H37.0192C34.7785 119.318 44.7099 103.97 49.4947 83.9985C48.4094 105.053 49.5881 113.298 43.9864 148.932Z",
    fill: "#627A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0058 148.932C34.7651 119.318 44.6965 103.97 49.4814 83.9985C44.2064 106.742 37.5076 120.308 37.0058 148.932Z",
    fill: "#424C46"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1189_1531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 79,
    width: 14,
    height: 69
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1067 146.288L38.0345 147.977C28.5465 118.48 34.8718 100.488 34.8602 79.0608C38.8981 100.686 42.1075 108.768 45.1067 146.277V146.288Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1189_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1067 146.288L38.0345 147.977C28.5465 118.48 34.8718 100.488 34.8602 79.0608C38.8981 100.686 42.1075 108.768 45.1067 146.277V146.288Z",
    fill: "#627A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.836 152.204L30.7638 153.893C21.2758 124.395 34.8717 100.488 34.8484 79.0608C36.9607 99.6495 31.8374 113.181 37.836 152.193V152.204Z",
    fill: "#424C46"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1189_1531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 85,
    width: 6,
    height: 63
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4461 147.185L62.0639 147.372C64.7014 119.435 60.3133 104.634 58.8195 85.6172C58.3294 105.565 57.3024 113.333 58.4344 147.174L58.4461 147.185Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1189_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4461 147.185L62.0639 147.372C64.7014 119.435 60.3133 104.634 58.8195 85.6172C58.3294 105.565 57.3024 113.333 58.4344 147.174L58.4461 147.185Z",
    fill: "#627A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4606 151.086L66.0784 151.273C68.7159 123.336 60.3132 104.634 58.8194 85.6172C59.2162 104.284 62.694 115.347 62.4489 151.075L62.4606 151.086Z",
    fill: "#424C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.7093 117.443L59.1112 140.233L58.4226 132.011L62.7056 110.98L63.7093 117.443Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1189_1531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 94,
    width: 14,
    height: 63
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8587 155.523L62.5538 156.932C71.1315 130.16 69.5793 112.028 67.1519 94.7236C63.2423 114.299 60.3948 121.647 56.8587 155.535V155.523Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1189_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3842 148.734L68.2019 152.146C82.6381 112.89 68.1319 87.1192 65.401 57.5637C60.4412 86.7815 55.3179 97.4485 54.3842 148.734Z",
    fill: "#627A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5886 160.728C62.5886 160.728 57.407 163.942 59.0291 153.078C60.3129 144.472 64.2808 112.11 67.1517 94.7002C48.4908 110.631 47.954 122.043 62.5886 160.717V160.728Z",
    fill: "#424C46"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1189_1531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 88,
    width: 12,
    height: 63
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5118 149.281L54.0931 150.819C45.4804 124.046 51.2222 107.72 51.2105 88.2722C54.875 107.906 57.7809 115.242 60.5118 149.281Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1189_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5118 149.281L54.0931 150.819C45.4804 124.046 51.2222 107.72 51.2105 88.2722C54.875 107.906 57.7809 115.242 60.5118 149.281Z",
    fill: "#627A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9065 154.65L47.4878 156.187C38.8751 129.415 51.2107 107.72 51.199 88.2722C53.1129 106.963 48.4565 119.248 53.9065 154.65Z",
    fill: "#424C46"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.675 140.14H68.6109V191.553C68.6109 191.786 68.4242 191.973 68.1908 191.973H29.0485C28.8384 191.973 28.675 191.798 28.675 191.6V140.14Z",
    fill: "#7C97C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.611 146.521H28.6751V151.191H68.611V146.521Z",
    fill: "#F9F9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M262.922 184.322H74.1311L95.9313 66.3558C96.7482 61.954 100.588 58.7632 105.069 58.7632H274.966C280.778 58.7632 285.154 64.0152 284.104 69.7213L262.934 184.322H262.922Z",
    fill: "#2C4165"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M258.522 186.313L77.0837 186.86L98.0903 73.1566C98.8723 68.9178 102.583 65.2961 106.901 65.2961H270.66C276.261 65.2961 279.937 70.3618 278.922 75.8583L258.511 186.325L258.522 186.313Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M234.902 191.215L257.472 191.041C259.923 191.017 262.012 189.259 262.444 186.86L263.821 179.209L233.711 179L234.89 191.215H234.902Z",
    fill: "#2C4165"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M242.686 191.215H53.4861C52.2958 191.215 51.2221 190.517 50.7436 189.434L47.9661 183.192C47.0908 181.212 48.5379 178.988 50.7086 178.988H245.463C247.634 178.988 249.081 181.212 248.206 183.192L245.428 189.434C244.95 190.517 243.876 191.215 242.686 191.215Z",
    fill: "#415E8F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.214 185.649H128.947C126.134 185.649 123.462 184.391 121.676 182.214L119.062 179.023H177.087L174.473 182.214C172.687 184.391 170.026 185.649 167.202 185.649H167.214Z",
    fill: "#7C97C6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.829 179.175L78.9741 178.988L98.627 72.5978C99.4089 68.359 102.572 65.2847 106.89 65.2847H270.648C276.249 65.2847 279.926 70.3503 278.91 75.8469L259.818 179.175H259.829Z",
    fill: "#F9F9FF"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M296.556 190.424H18.6387C17.1047 190.424 15.8611 191.664 15.8611 193.195V195.978C15.8611 197.509 17.1047 198.75 18.6387 198.75H296.556C298.09 198.75 299.334 197.509 299.334 195.978V193.195C299.334 191.664 298.09 190.424 296.556 190.424Z",
    fill: "#2C4165"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.823 135.505C148.074 152.122 173.096 153.31 188.08 146.905C200.031 141.805 210.126 129.938 207.757 124.104C205.901 119.528 197.86 122.334 187.754 114.916C180.623 109.676 181.697 106.136 175.115 101.664C169.174 97.6346 158.706 94.0129 150.292 97.8093C138.143 103.294 133.487 122.777 139.812 135.505H139.823Z",
    fill: "#DE725E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.321 130.8L179.328 118.118L193.834 105.367C195.024 104.319 195.258 102.619 194.359 101.582L191.115 97.8442C190.216 96.7961 188.512 96.8078 187.322 97.8442L172.816 110.596L161.822 97.9141C160.924 96.866 159.22 96.8776 158.03 97.9141L153.747 101.675C152.556 102.724 152.323 104.424 153.221 105.46L164.215 118.142L149.709 130.893C148.518 131.941 148.285 133.641 149.183 134.678L152.428 138.416C153.326 139.464 155.03 139.452 156.221 138.416L170.727 125.665L181.72 138.346C182.619 139.394 184.323 139.383 185.513 138.346L189.796 134.585C190.987 133.537 191.22 131.836 190.321 130.8Z",
    fill: "#EE8678"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiabilityImage);
export default __webpack_public_path__ + "static/media/fiability-image.587c91b8dd6094cbad73ee598ee4d413.svg";
export { ForwardRef as ReactComponent };